(() => {
  if (window.__chrmPremium2026) return;
  window.__chrmPremium2026 = true;

  const onReady = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  const storeRoot = () => {
    const root = window.Shopify?.routes?.root || '/';
    return root.endsWith('/') ? root : root + '/';
  };

  const money = (cents) => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  };

  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));

  const productJson = async (handle) => {
    const response = await fetch(`${storeRoot()}products/${handle}.js`, { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Product unavailable');
    return response.json();
  };

  onReady(() => {
    /* Premium mobile navigation drawer */
    const openBtn = document.querySelector('[data-chrm-menu-open]');
    const closeBtn = document.querySelector('[data-chrm-menu-close]');
    const drawer = document.querySelector('[data-chrm-mobile-drawer]');
    const scrim = document.querySelector('[data-chrm-menu-scrim]');

    const setMenu = (open) => {
      if (!drawer || !scrim || !openBtn) return;
      drawer.classList.toggle('is-open', open);
      scrim.classList.toggle('is-open', open);
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.body.classList.toggle('chrm-menu-open', open);
      if (open && closeBtn) window.setTimeout(() => closeBtn.focus(), 120);
      if (!open && document.activeElement === closeBtn) openBtn.focus();
    };

    openBtn?.addEventListener('click', () => setMenu(true));
    closeBtn?.addEventListener('click', () => setMenu(false));
    scrim?.addEventListener('click', () => setMenu(false));
    drawer?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => setMenu(false)));
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape') setMenu(false); });

    /* Keep previously requested IG CTA clean: no decorative arrow. */
    document.querySelectorAll('.studio-social__head a').forEach((link) => {
      link.textContent = (link.textContent || '').replace(/[↗→]\s*$/, '').trim();
    });

    /* Hero copy/product must match the black suede Margot image. */
    const hero = document.querySelector('.studio-home .studio-hero--campaign');
    if (hero) {
      const deck = hero.querySelector('.studio-hero__deck');
      const primary = hero.querySelector('.studio-button--hero');
      const productChip = hero.querySelector('.studio-hero__product--overlay');
      if (deck) deck.textContent = 'The Margot Boot just landed — black suede, a sharp point and the easiest way to finish the look.';
      if (primary) {
        primary.href = `${storeRoot()}products/margot-boot`;
        primary.innerHTML = 'SHOP MARGOT <span>↗</span>';
      }
      productJson('margot-boot').then((margot) => {
        if (!productChip || !margot) return;
        productChip.href = `${storeRoot()}products/margot-boot`;
        const name = productChip.querySelector('strong');
        const price = productChip.querySelector('b');
        if (name) name.textContent = margot.title;
        if (price) price.textContent = `${money(margot.price)} ↗`;
      }).catch(() => {});
    }

    /* Product page CRO polish, built on the existing fast native theme. */
    const pdp = document.querySelector('.chrm-site.chrm-pdp');
    if (pdp) {
      const mainAdd = pdp.querySelector('.chrm-pdp-add, .chrm-pdp-submit');
      const buyPanel = pdp.querySelector('.chrm-pdp-buy');
      const price = pdp.querySelector('[data-chrm-price], #ChrmPdpPrice, .chrm-pdp-price');
      const title = pdp.querySelector('.chrm-pdp-heading h1, .chrm-pdp-buy h1');

      /* Customer-centric trust wording instead of platform-centric wording. */
      pdp.querySelectorAll('.chrm-pdp-trust-item p').forEach((node) => {
        if (/powered by shopify/i.test(node.textContent || '')) node.textContent = 'Encrypted checkout. Cards + express payment options available.';
      });

      if (mainAdd && !mainAdd.disabled && buyPanel && !buyPanel.querySelector('.chrm-pdp-stock')) {
        const stock = document.createElement('div');
        stock.className = 'chrm-pdp-stock';
        stock.innerHTML = '<i aria-hidden="true"></i><span>AVAILABLE TO ORDER</span>';
        mainAdd.parentNode.insertBefore(stock, mainAdd);

        const proof = document.createElement('div');
        proof.className = 'chrm-pdp-proof';
        proof.innerHTML = '<span><b>30 DAYS</b><small>Return requests</small></span><span><b>1–3 DAYS</b><small>Processing</small></span><span><b>SECURE</b><small>Checkout</small></span>';
        const dynamicCheckout = buyPanel.querySelector('.chrm-dynamic-checkout');
        if (dynamicCheckout) dynamicCheckout.insertAdjacentElement('afterend', proof);
        else mainAdd.insertAdjacentElement('afterend', proof);
      }

      /* Outfit-driven, category-aware cross-sell. */
      const related = pdp.querySelector('.chrm-related');
      const reviews = pdp.querySelector('.chrm-reviews');
      if (related) {
        related.classList.add('is-complete-look');
        const eyebrow = related.querySelector('.chrm-eyebrow');
        const heading = related.querySelector('h2');
        const aside = related.querySelector('.chrm-section-head__aside');
        if (eyebrow) eyebrow.textContent = 'STYLE IT WITH';
        if (heading) heading.textContent = 'Complete the look.';
        if (aside) aside.innerHTML = '<span style="font:700 8px/1 var(--sans,Arial,sans-serif);letter-spacing:.1em;color:#6b635c">PICKED FOR THIS CATEGORY</span>';
        if (reviews) reviews.parentNode.insertBefore(related, reviews);

        const categoryText = (pdp.querySelector('.chrm-pdp-heading .chrm-eyebrow')?.textContent || '').toUpperCase();
        let handles = ['fringe-bag', 'mara-bag', 'lumi-bag', 'noa-bag'];
        if (categoryText.includes('HANDBAGS')) handles = ['margot-boot', 'sloane-boot', 'romy-boot', 'blair-boot'];
        else if (!categoryText.includes('BOOTS')) handles = ['margot-boot', 'fringe-bag', 'lumi-bag', 'sloane-boot'];

        const currentHandle = window.location.pathname.split('/products/')[1]?.split(/[?#/]/)[0];
        handles = handles.filter((handle) => handle !== currentHandle);
        Promise.all(handles.map((handle) => productJson(handle).catch(() => null))).then((items) => {
          const products = items.filter(Boolean).slice(0, 4);
          const grid = related.querySelector('.chrm-product-grid');
          if (!grid || products.length < 2) return;
          grid.classList.add('is-smart-complete');
          grid.innerHTML = products.map((item) => {
            const image = item.featured_image || item.images?.[0] || '';
            const sized = image ? `${image}${image.includes('?') ? '&' : '?'}width=720` : '';
            return `<a class="chrm-complete-card" href="${storeRoot()}products/${encodeURIComponent(item.handle)}"><span class="chrm-complete-card__media">${sized ? `<img src="${escapeHtml(sized)}" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}</span><span class="chrm-complete-card__meta"><strong>${escapeHtml(item.title)}</strong><span>${money(item.price)}</span></span><span class="chrm-complete-card__cta">VIEW ITEM <b>→</b></span></a>`;
          }).join('');
        }).catch(() => {});
      }

      /* Mobile sticky purchase bar. It mirrors the selected variant and never invents urgency. */
      if (mainAdd && buyPanel && !pdp.querySelector('[data-chrm-sticky-buy]')) {
        const sticky = document.createElement('div');
        sticky.className = 'chrm-pdp-sticky-buy';
        sticky.setAttribute('data-chrm-sticky-buy', '');
        sticky.innerHTML = `<div class="chrm-pdp-sticky-buy__meta"><span>${escapeHtml((title?.textContent || 'CHRM. STUDIO').trim())}</span><strong data-chrm-sticky-price>${escapeHtml((price?.textContent || '').trim())}</strong></div><button type="button" data-chrm-sticky-action>ADD TO BAG</button>`;
        pdp.appendChild(sticky);
        pdp.classList.add('has-chrm-sticky');

        const stickyButton = sticky.querySelector('[data-chrm-sticky-action]');
        const stickyPrice = sticky.querySelector('[data-chrm-sticky-price]');
        const syncSticky = () => {
          if (stickyPrice && price) stickyPrice.textContent = price.textContent.trim();
          if (stickyButton) {
            stickyButton.disabled = !!mainAdd.disabled;
            const label = (mainAdd.textContent || '').replace(/\s+/g, ' ').trim();
            stickyButton.textContent = mainAdd.disabled ? 'SOLD OUT' : (/add/i.test(label) ? 'ADD TO BAG' : label || 'ADD TO BAG');
          }
        };
        syncSticky();
        if (price) new MutationObserver(syncSticky).observe(price, { childList: true, characterData: true, subtree: true });
        new MutationObserver(syncSticky).observe(mainAdd, { attributes: true, childList: true, characterData: true, subtree: true });
        buyPanel.querySelectorAll('input,select').forEach((field) => field.addEventListener('change', () => window.setTimeout(syncSticky, 0)));
        stickyButton?.addEventListener('click', () => { if (!mainAdd.disabled) mainAdd.click(); });

        if ('IntersectionObserver' in window) {
          const buttonObserver = new IntersectionObserver((entries) => {
            sticky.classList.toggle('is-visible', !entries[0]?.isIntersecting && window.scrollY > 180);
          }, { threshold: .15 });
          buttonObserver.observe(mainAdd);
          const footer = pdp.querySelector('.chrm-brand-footer');
          if (footer) {
            const footerObserver = new IntersectionObserver((entries) => {
              sticky.classList.toggle('is-footer-near', !!entries[0]?.isIntersecting);
            }, { threshold: 0 });
            footerObserver.observe(footer);
          }
        } else {
          window.addEventListener('scroll', () => sticky.classList.toggle('is-visible', window.scrollY > 520), { passive: true });
        }
      }
    }

    /* Cart AOV ladder: boots → bag; bag → case remains the native cart upsell. */
    const cart = document.querySelector('.chrm-site.chrm-cart');
    if (cart) {
      const lineHrefs = Array.from(cart.querySelectorAll('.chrm-cart-line__top a, .chrm-cart-line__image')).map((a) => a.getAttribute('href') || '');
      const bootHandles = ['sloane-boot','romy-boot','margot-boot','blair-boot'];
      const bagHandles = ['fringe-bag','noa-bag','sloane-bag','mara-bag','rue-bag','vale-bag','lumi-bag','nola-bag'];
      const hasBoot = bootHandles.some((handle) => lineHrefs.some((href) => href.includes(`/products/${handle}`)));
      const hasBag = bagHandles.some((handle) => lineHrefs.some((href) => href.includes(`/products/${handle}`)));
      const summary = cart.querySelector('.chrm-cart-summary');

      if (hasBoot && !hasBag && summary && !summary.querySelector('[data-chrm-bag-upsell]')) {
        const candidates = ['fringe-bag','mara-bag','lumi-bag','noa-bag'];
        const handle = candidates[Math.floor(Math.random() * candidates.length)];
        productJson(handle).then((item) => {
          const variant = item.variants?.find((v) => v.available) || item.variants?.[0];
          if (!variant) return;
          const section = document.createElement('section');
          section.className = 'chrm-cart-upsell';
          section.setAttribute('data-chrm-bag-upsell', '');
          const image = item.featured_image || item.images?.[0] || '';
          section.innerHTML = `<p class="chrm-cart-upsell__eyebrow">COMPLETE THE LOOK</p><div class="chrm-cart-upsell__head"><strong>Add a bag?</strong><span>Picked to work with the boot edit.</span></div><article class="chrm-cart-upsell__card"><a class="chrm-cart-upsell__image" href="${storeRoot()}products/${escapeHtml(item.handle)}">${image ? `<img src="${escapeHtml(image)}${image.includes('?') ? '&' : '?'}width=320" alt="${escapeHtml(item.title)}" loading="lazy">` : ''}</a><div class="chrm-cart-upsell__info"><div class="chrm-cart-upsell__meta"><a href="${storeRoot()}products/${escapeHtml(item.handle)}">${escapeHtml(item.title)}</a><span>${money(variant.price)}</span></div><button type="button" class="chrm-cart-upsell__add" data-chrm-add-bag>+ ADD TO BAG</button></div></article>`;
          const firstInfo = Array.from(summary.children).find((el) => el.tagName === 'P');
          summary.insertBefore(section, firstInfo || summary.querySelector('.chrm-checkout'));
          const button = section.querySelector('[data-chrm-add-bag]');
          button?.addEventListener('click', async () => {
            if (button.disabled) return;
            button.disabled = true;
            button.textContent = 'ADDING…';
            try {
              const response = await fetch(`${storeRoot()}cart/add.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variant.id), quantity: 1 }] }) });
              if (!response.ok) throw new Error('Unable to add');
              button.textContent = 'ADDED ✓';
              window.location.reload();
            } catch (_) {
              button.disabled = false;
              button.textContent = 'TRY AGAIN';
            }
          });
        }).catch(() => {});
      }

      const emptyCartCta = cart.querySelector('.chrm-empty-cart .chrm-button');
      if (emptyCartCta && /bags/i.test(emptyCartCta.textContent || '')) emptyCartCta.innerHTML = 'SHOP CHRM. STUDIO <span>→</span>';
    }
  });
})();
